import ReactDOMServer from 'react-dom/server';
import { CurrentAmeyoCallStatus } from '@cp/src/service/naviExtension.service';
import { AmeyoCallState } from '@cp/components/Ameyo/constants';

export const jsxToString = (element: React.ReactElement<SVGElement>) =>
  ReactDOMServer.renderToString(element);

export function getCurrentAmeyoCallState(ameyoCallData: CurrentAmeyoCallStatus) {
  if (ameyoCallData?.ringingAt && !ameyoCallData.disconnectedAt) {
    return ameyoCallData.acceptedAt ? AmeyoCallState.TALKING : AmeyoCallState.RINGING;
  }

  return AmeyoCallState.IDLE;
}
